import { loadSettingsFromLocalStorage } from './localStorage';
import { initSettingsModal } from './modal';
import { applySettings } from './applySettings';
import { displaySettingsButton } from './displaySettings';

/**
 * Initializes the settings system by loading saved settings,
 * setting up the modal, applying settings, and conditionally
 * displaying the settings button
 */
export function initSettings() {
  loadSettingsFromLocalStorage();
  initSettingsModal();
  applySettings();

  // Display settings button if conditions are met
  displaySettingsButton();
}
